/* Box Pareja — lógica de la PDP (El Taba) */
(function () {
  'use strict';

  // ── Ocultar header/announcement/footer nativos del theme ──
  function hideNativeChrome() {
    var page = document.querySelector('.box-pareja-page');
    if (!page) return;
    var node = page;
    while (node.parentElement && node.parentElement !== document.body) { node = node.parentElement; }
    Array.prototype.forEach.call(document.body.children, function (child) {
      if (child === node) return;
      var tag = child.tagName;
      if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT') return;
      var cs = window.getComputedStyle(child);
      if (cs.position === 'fixed' && parseInt(cs.zIndex, 10) > 100) return; // preservar WhatsApp, etc.
      child.style.display = 'none';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hideNativeChrome);
  else hideNativeChrome();

  // ── Precio desde Shopify (window.BOX_PRICE / BOX_COMPARE en pesos) ──
  var UNIT    = (typeof window.BOX_PRICE   === 'number' && window.BOX_PRICE > 0) ? window.BOX_PRICE : 0;
  var COMPARE = (typeof window.BOX_COMPARE === 'number') ? window.BOX_COMPARE : 0;
  function fmt(n) { return '$' + Math.round(n).toLocaleString('es-AR'); }
  var hasCompare = COMPARE && COMPARE > UNIT;
  var off = hasCompare ? Math.round((COMPARE - UNIT) / COMPARE * 100) : 0;
  var $$ = function (sel) { return document.querySelectorAll('.box-pareja-page ' + sel); };
  if (UNIT > 0) $$('[data-role="price"]').forEach(function (el) { el.textContent = fmt(UNIT); });
  $$('[data-role="compare"]').forEach(function (el) { el.style.display = hasCompare ? '' : 'none'; if (hasCompare) el.textContent = fmt(COMPARE); });
  $$('[data-role="badge"]').forEach(function (el) { el.style.display = hasCompare ? '' : 'none'; if (hasCompare) el.textContent = off + '% OFF'; });

  // ── Qty + breakdown (todo deriva de UNIT = product.price) ──
  var qty = 1, MIN = 1, MAX = 5;
  function byId(id) { return document.getElementById(id); }
  function update() {
    if (!UNIT) return;
    var total = UNIT * qty;
    if (byId('qty-display'))  byId('qty-display').textContent = qty;
    if (byId('bd-box-label')) byId('bd-box-label').textContent = 'Box Pareja × ' + qty;
    if (byId('bd-box-val'))   byId('bd-box-val').textContent = fmt(total);
    if (byId('bd-total'))     byId('bd-total').textContent = fmt(total);
    if (byId('btn-total'))    byId('btn-total').textContent = fmt(total);
    if (byId('qty-minus'))    byId('qty-minus').disabled = qty <= MIN;
    if (byId('qty-plus'))     byId('qty-plus').disabled = qty >= MAX;
  }
  window.changeQty = function (d) { qty = Math.max(MIN, Math.min(MAX, qty + d)); update(); };

  // ── Shopify Cart API: agregar al carrito + redirect a /checkout ──
  window.handleBuyBox = async function () {
    var variantId = window.BOX_VARIANT_ID;
    if (!variantId) { console.error('Box Pareja: variant ID no definido'); return; }
    var btns = document.querySelectorAll('.box-pareja-page .fc-btn');
    btns.forEach(function (b) { b.disabled = true; });
    try {
      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
      });
      if (response.ok) { window.location.href = '/checkout'; }
      else { console.error('Box Pareja: error al agregar al carrito', await response.text()); btns.forEach(function (b) { b.disabled = false; }); }
    } catch (err) { console.error('Box Pareja: error de red', err); btns.forEach(function (b) { b.disabled = false; }); }
  };

  update();
})();

/* ── Banner sticky que crece al scroll ── */
(function () {
  var b = document.getElementById('pbar'); if (!b) return; var t = false;
  function u() {
    var y = window.scrollY, h = document.documentElement.scrollHeight - window.innerHeight, p = h > 0 ? y / h : 0;
    b.classList.remove('is-grown', 'is-mega');
    if (p >= 0.75) b.classList.add('is-mega'); else if (y > 200) b.classList.add('is-grown'); t = false;
  }
  window.addEventListener('scroll', function () { if (!t) { requestAnimationFrame(u); t = true; } }, { passive: true }); u();
})();

/* ── FAQ accordion ── */
document.querySelectorAll('.box-pareja-page .faq-item').forEach(function (i) {
  var r = i.querySelector('.faq-q-row'); if (r) r.addEventListener('click', function () { i.classList.toggle('open'); });
});

/* ── Carrusel del hero (manual con flechas/dots + autoplay) ── */
(function () {
  var cat = document.querySelector('.box-pareja-page .hero-right .cat'); if (!cat) return;
  var sl = cat.querySelectorAll('.cat-slide'), dt = cat.querySelectorAll('.cat-dot');
  if (sl.length < 2) return;
  var i = 0, timer = null;
  function go(n) {
    sl[i].classList.remove('is-active'); if (dt[i]) dt[i].classList.remove('is-active');
    i = (n + sl.length) % sl.length;
    sl[i].classList.add('is-active'); if (dt[i]) dt[i].classList.add('is-active');
  }
  function play() { timer = setInterval(function () { go(i + 1); }, 3200); }
  function reset() { clearInterval(timer); play(); }
  var next = cat.querySelector('.cat-next'), prev = cat.querySelector('.cat-prev');
  if (next) next.addEventListener('click', function () { go(i + 1); reset(); });
  if (prev) prev.addEventListener('click', function () { go(i - 1); reset(); });
  dt.forEach(function (d, idx) { d.addEventListener('click', function () { go(idx); reset(); }); });
  play();
})();
